module.exports = __webpack_public_path__ + "static/flags/QA-f9f2d31e9ba381cf677607bf858b310d.gif";